export default {"src":"/_next/static/media/bg_purple_m.8d54584a.svg","height":725,"width":639,"blurWidth":0,"blurHeight":0};